class GedeonProductCardWishlist {
  constructor() {
    this.storageKey = 'gedeon:wishlist';
    this.buttons = [];
  }

  init() {
    this.buttons = Array.from(document.querySelectorAll('[data-gedeon-wishlist]'));
    if (!this.buttons.length) return;

    const saved = this.readSaved();
    this.buttons.forEach((button) => {
      const handle = button.getAttribute('data-product-handle');
      if (!handle) return;

      this.setPressed(button, saved.includes(handle));
      button.addEventListener('click', () => this.toggle(button, handle));
    });
  }

  readSaved() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(this.storageKey) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  writeSaved(saved) {
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(saved));
    } catch {
      return;
    }
  }

  setPressed(button, pressed) {
    button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    button.classList.toggle('is-active', pressed);
  }

  toggle(button, handle) {
    const saved = this.readSaved();
    const exists = saved.includes(handle);
    const next = exists ? saved.filter((item) => item !== handle) : [...saved, handle];

    this.writeSaved(next);
    this.setPressed(button, !exists);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new GedeonProductCardWishlist().init();
});
